import '../../styles/globals.css'
import { initViewport } from '../../utils/viewport'
import { Game } from './Game'

// Init viewport height detection for mobile
initViewport()

// DOM Elements
const canvas = document.getElementById('game-canvas') as HTMLCanvasElement
const scoreElement = document.getElementById('score') as HTMLSpanElement
const linesElement = document.getElementById('lines') as HTMLSpanElement
const gameOverOverlay = document.getElementById('game-over-overlay') as HTMLDivElement
const finalScoreElement = document.getElementById('final-score') as HTMLSpanElement
const restartButton = document.getElementById('restart-button') as HTMLButtonElement

// Initialize game
let game: Game | null = null

function updateScore(score: number): void {
  scoreElement.textContent = score.toString()
}

function updateLines(lines: number): void {
  linesElement.textContent = lines.toString()
}

function showGameOver(finalScore: number): void {
  finalScoreElement.textContent = finalScore.toString()
  gameOverOverlay.classList.remove('hidden')
}

function hideGameOver(): void {
  gameOverOverlay.classList.add('hidden')
}

function initGame(): void {
  if (game) {
    game.stop()
  }

  game = new Game({
    canvas,
    onScoreChange: updateScore,
    onLinesChange: updateLines,
    onGameOver: showGameOver,
  })

  game.start()
}

// Event listeners
restartButton.addEventListener('click', () => {
  hideGameOver()
  if (game) {
    game.restart()
  }
})

// Handle window resize
window.addEventListener('resize', () => {
  if (game) {
    game.handleResize()
  }
})

// Start the game
initGame()
